import React from 'react'
import css from './section.module.css'
import Card from './Card'
import Card2 from './Card2'
import {FaLayerGroup, FaCode} from 'react-icons/fa'
import {HiShieldCheck} from 'react-icons/hi'
import resources from '../../../../resources/index'
const Section2 = () => {
  const features = [
    {
      image: <FaLayerGroup />,
      bg: '#175cff',
      title: "Good Performance",
      desc: 'Appropriately grow competitive leadership rather than strategic technically sound processes without state.'
    },
    {
      image: <HiShieldCheck />,
      bg: '#f25767',
      title: "Highly Secure",
      desc: 'Appropriately grow competitive leadership rather than strategic technically sound processes without state.'
    },
    {
      image: <FaCode />,
      bg: '#0b163f',
      title: "Fast Development",
      desc: 'Appropriately grow competitive leadership rather than strategic technically sound processes without state.'
    },
  ]

  const features2 = [
    {
      image: resources.images.home_sec3_1,
      title: 'Utilize your software data',
      desc: 'Progressively reinvent models and niche revolutionary benefits for integrated niches.',
      bg: "rgba(242,87,103,.2)"
    },
    {
      image: resources.images.home_sec3_2,
      title: 'Get real time updated anytime',
      desc: 'Progressively reinvent models and niche revolutionary benefits for integrated niches.',
      bg: "rgba(23,92,255,.2)"
    },
  ]

  return (
    <div className={css.section2}>

      <div className={css.feature_intro}>
        <h2>With all the Features You Need</h2>
        <p>Credibly grow premier ideas rather than bricks-and-clicks strategic theme areas distributed for stand-alone web-readiness.</p>
      </div>

      <div className={css.features}>
        {features.map((feature,index)=>{
          return(
          <Card key={index} feature = {feature} />
          )
        })}
      </div>

      <div className={css.features2}>
        {features2.map((feature,index)=>{
          return(
          <Card2 key={index} feature = {feature} />
          )
        })}
      </div>
      
    </div>
  )
}

export default Section2